import { isEmpty } from "lodash";
import { IBalanceDetails } from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";

export default (data: IBalanceDetails[]) => {
  if (!data || isEmpty(data)) return [];

  return data
    .filter((balance) => balance.absenceTypeInfo.active)
    .map((balance) => ({
      id: balance.absenceTypeInfo.id,
      name: balance.absenceTypeInfo.name,
    }));
};
